module.exports = __webpack_public_path__ + "media/22.5e5544b4.wav";